import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card border-0 rounded-0 bg-white mb-25"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25 letter-spacing" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-items-end justify-content-start flex-1 ms-auto"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex justify-content-between gap-3 flex-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "fw-medium text-body-tertiary mb-10"
}
const _hoisted_7 = {
  key: 1,
  class: "form-check form-switch d-inline-block d-flex gap-2 ms-auto mb-10"
}
const _hoisted_8 = {
  class: "form-check-label fw-medium position-relative",
  for: "show_prn"
}
const _hoisted_9 = {
  key: 2,
  class: "mb-25"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleTherapy = _resolveComponent("ScheduleTherapy")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_TherapyList = _resolveComponent("TherapyList")!
  const _component_TherapyIntakeCalendar = _resolveComponent("TherapyIntakeCalendar")!
  const _component_FKAccordion = _resolveComponent("FKAccordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" SCHEDULE THERAPY BLOCK "),
    (_ctx.update_enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.schedule_therapy === true)
              ? (_openBlock(), _createBlock(_component_ScheduleTherapy, {
                  key: 0,
                  patient: _ctx.patient,
                  onScheduled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.therapyScheduled($event))),
                  onDiscard: _ctx.discardTherapySchedule
                }, null, 8 /* PROPS */, ["patient", "onDiscard"]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ADD THERAPY "),
            (!_ctx.schedule_therapy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "default-btn transition fw-medium fs-md-15 fs-lg-16",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.provideTherapy && _ctx.provideTherapy(...args)))
                  }, _toDisplayString(_ctx.$t('feature.therapy.provide_therapy')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" THERAPIES LIST "),
    _createVNode(_component_FKAccordion, {
      id: "therapies",
      title: _ctx.$t('feature.therapy.name'),
      class: "mb-25"
    }, {
      default: _withCtx(() => [
        (_ctx.all_therapies === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_ctx.all_therapies.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('feature.therapy.no_therapy_scheduled')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" ACTIVE THERAPIES "),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.active_therapies && _ctx.active_therapies.length !== 0)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_6, _toDisplayString(_ctx.$tc('feature.therapy.active_therapies', _ctx.active_therapies.length)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" SHOW PRN "),
          (_ctx.prn_enabled && _ctx.all_therapies?.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none",
                  type: "checkbox",
                  id: "show_prn",
                  role: "switch",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show_prn_therapies) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.show_prn_therapies]
                ]),
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('feature.therapy.show_prn')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.active_therapies?.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_TherapyList, {
                therapies: _ctx.active_therapies ?? [],
                patient: _ctx.patient,
                show_stats: true,
                show_actions: true,
                onStop: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stopTherapy($event))),
                show_overall_trend: true
              }, null, 8 /* PROPS */, ["therapies", "patient"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" DAILY CALENDAR "),
        _createVNode(_component_FKAccordion, {
          id: "therapies_calendar",
          class: "mb-25",
          title: _ctx.$t('feature.therapy.daily_calendar')
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.all_therapies !== undefined)
                  ? (_openBlock(), _createBlock(_component_TherapyIntakeCalendar, {
                      key: 0,
                      therapies: _ctx.all_therapies ?? [],
                      patient: _ctx.patient
                    }, null, 8 /* PROPS */, ["therapies", "patient"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createCommentVNode(" INACTIVE THERAPIES "),
        (_ctx.inactive_therapies && _ctx.inactive_therapies?.length !== 0)
          ? (_openBlock(), _createBlock(_component_FKAccordion, {
              key: 3,
              id: "inactive-therapies",
              title: _ctx.$tc('feature.therapy.inactive_therapies', _ctx.inactive_therapies?.length ?? 0)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TherapyList, {
                  therapies: _ctx.inactive_therapies ?? [],
                  patient: _ctx.patient,
                  show_stats: true,
                  show_actions: true,
                  onDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteTherapy($event)))
                }, null, 8 /* PROPS */, ["therapies", "patient"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"])
  ], 64 /* STABLE_FRAGMENT */))
}